const ModuleItems =
[
    {
        "id":1,
        'name':'Manages financial transactions, budgeting, and reporting for accurate financial data and compliance.'
    },
    {
        "id":2,
        "name":'Oversees manufacturing processes, resource planning, and production schedules to optimize output.'
    },
    {
        "id":3,
        "name":' Manages employee data, payroll, performance, and compliance with labor regulations.'
    },
    {
        "id":4,
        "name":'Helps in demand forecasting, capacity planning, and aligning resources with business goals.'
    },
    {
        "id":5,
        "name":'Tracks stock levels, orders, and warehousing to ensure optimal inventory control.'
    },
    {
        "id":6,
        "name":'Provides insights and analytics through real-time data reporting for better decision-making.'
    },
    {
        "id":7,
        "name":'Manages customer interactions, sales, and marketing to improve customer satisfaction.'
    },
    {
        "id":8,
        "name":'Automates sales and marketing processes, improving lead management and customer engagement.'
    },
    
]
export default ModuleItems;
